import { __assign, __spreadArrays } from "tslib";
import * as sanitize from 'sanitize-html';
import * as DOMPurify from 'dompurify';
import { isFeatureEnabled } from '@wix/answers-experiments';
var _sanitizeHtmlSanitizer = function (html) {
    return sanitize(html, {
        allowedTags: sanitize.defaults.allowedTags.concat(['bold', 'img', 'span']),
        allowedAttributes: __assign(__assign({}, sanitize.defaults.allowedAttributes), { img: __spreadArrays(sanitize.defaults.allowedAttributes.img, ['class', 'height', 'width']), div: ['class'], span: ['class'], strong: ['class'], bold: ['class'], a: ['class', 'href', 'target'] }),
        transformTags: {
            img: function (tagName, attribs) {
                // My own custom magic goes here
                var rawSrc = attribs.src || '';
                var processedSrc = rawSrc.replace('http://', 'https://');
                return {
                    tagName: tagName,
                    attribs: __assign(__assign({}, attribs), { src: processedSrc })
                };
            }
        }
    });
};
var _domPurifySanitizer = function (html) {
    // taken form https://github.com/apostrophecms/sanitize-html as we migrated from it to dompurify to be consistent
    var DEFAULT_ALLOWED_TAGS_FROM_SANITIZE_HTML = [
        'address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4',
        'h5', 'h6', 'hgroup', 'main', 'nav', 'section', 'blockquote', 'dd', 'div',
        'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre',
        'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
        'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp',
        'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr', 'caption',
        'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'img', 'bold', 'span'
    ];
    var DEFAULT_ALLOWED_TAGS = __spreadArrays(DEFAULT_ALLOWED_TAGS_FROM_SANITIZE_HTML, [
        'img',
        'bold',
        'span'
    ]);
    var DEFAULT_ALLOWED_ATTRS = ['class', 'src', 'bold', 'img', 'span', 'href', 'target'];
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.tagName === 'IMG') {
            var rawSrc = node.getAttribute('src') || '';
            if (rawSrc) {
                var processedSrc = rawSrc.replace('http://', 'https://');
                node.setAttribute('src', processedSrc);
            }
        }
    });
    var sanitizedHtml = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: DEFAULT_ALLOWED_TAGS,
        ALLOWED_ATTR: DEFAULT_ALLOWED_ATTRS
    });
    DOMPurify.removeAllHooks();
    return sanitizedHtml;
};
export var sanitizeHtml = function (html) {
    if (isFeatureEnabled('LibbyUseDomPurifySanitizer')) {
        return _domPurifySanitizer(html);
    }
    else {
        return _sanitizeHtmlSanitizer(html);
    }
};
//# sourceMappingURL=sanitizer.js.map